import { createStyles } from '../../../../styles/helpers'
import { transitionShort } from '../../../../styles/const/common'

const useStyles = createStyles({
  thumbnail: {
    width: 40,
    height: 40,
    objectFit: 'contain'
  },
  isClickable: {
    cursor: 'pointer',
    transition: transitionShort,
    '&:hover': {
      opacity: 0.8
    }
  }
})

export default useStyles
